import { AnamnesisState, AnamnesisStep, AnamnesisStepName, AnamnesisStepType } from '../@types/Patient'

import { paths } from './routes'

export const DOCUMENT_PATH_PREFIX = '/document'

export const stepNameToPathSegment = (stepName: string): string => stepName.toLowerCase().replace(/_/g, '-')

const STEP_ENTRY_PATHS: Record<string, (step: AnamnesisStep) => string | null> = {
  [AnamnesisStepName.ANAMNESIS]: () => paths.personalInformation,
  [AnamnesisStepName.FACTORING_AGREEMENT]: () => paths.factoringAgreement,
}

export const getStepEntryPath = (step: AnamnesisStep): string | null => {
  const resolver = STEP_ENTRY_PATHS[step.step]

  if (resolver) return resolver(step)

  if (step.type === AnamnesisStepType.DOCUMENT) {
    return `${DOCUMENT_PATH_PREFIX}/${stepNameToPathSegment(step.step)}`
  }

  return null
}

export const RENDERABLE_STATUSES: ReadonlySet<AnamnesisState> = new Set([
  AnamnesisState.IN_PROGRESS,
  AnamnesisState.MISSING,
  AnamnesisState.EXPIRED,
])

export const isRenderableStep = (step: AnamnesisStep): boolean => RENDERABLE_STATUSES.has(step.status)

export type FlowStep = {
  step: AnamnesisStep
  entryPath: string
}

export const buildFlow = (anamnesisState: AnamnesisStep[] | undefined): FlowStep[] => {
  if (!anamnesisState) return []

  return anamnesisState
    .filter(isRenderableStep)
    .map((step) => {
      const entryPath = getStepEntryPath(step)

      return entryPath ? { step, entryPath } : null
    })
    .filter((entry): entry is FlowStep => entry !== null)
}
